import script from "./HelpAgent.vue?vue&type=script&setup=true&lang=js"
export * from "./HelpAgent.vue?vue&type=script&setup=true&lang=js"

import "./HelpAgent.vue?vue&type=style&index=0&id=7ebb177b&lang=css"

const __exports__ = script;

export default __exports__